import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import Axios from 'axios';
import moment from 'moment';

import APP_CONSTANTS from '../../config/constants';
import AddTitleBar from '../titleBar/addTitleBar';
import { DateData } from '../formikInput/date';
import ActiveVendorBills from './activeVendorBills';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import PaidInvoices from './paidInvoices';

//Dropdowns
import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
import PaymentModeDropdown from '../dropdowns/paymentModeDropdown';
import BankDropdown from '../dropdowns/bankDropdown';

//Actions 
import { updateReceivable, getReceivables } from '../../redux/actions/receivableActions';
import { getBillingCustomerInvoice } from '../../redux/actions/customerInvoiceActions';
import { LOCAL_STORAGE } from '../utils/constants';
import { dateFormats } from '../../utils/constant';
import { ERROR_MESSAGES } from '../../config/const';
import { buttons, fields } from './receivable.constants';
import BranchDropdown from '../dropdowns/branchDropdown';

const EditReceivable = (props) => {

    const { getReceivables, updateReceivable, getBillingCustomerInvoice, receivableData, billingCustomerInvoiceData, receivableLoading, billingCustomerInvoiceLoading } = props;

    const [paymentName, setPaymentName] = useState("")
    const [paymentData, setPaymentData] = useState([]);
    const [mappedPayment, setMappedPayment] = useState([]);
    const [branchData, setBranchData] = useState([]);
    // console.log(props,'props receivable')
    // console.log('getReceivables',getReceivables)


    const paymentSelected = childData => {

        let addedPaymentMode = paymentData.filter(e => {
            // console.log("Payment Code ", e.paymentModeCode)
            return e.paymentModeCode === childData
        })
        setPaymentName(addedPaymentMode && addedPaymentMode.length > 0 && addedPaymentMode[0].paymentModeName)

        // console.log("ChildData", childData, paymentName, addedPaymentMode)
    }



    useEffect(() => {
        const id = props.location.state.id
        const paymentID = props.location.state.paymentId
        const vendorCode = props.location.state.vendorCode
        const edit = true

        // console.log("Payument Id ", paymentID)

        getReceivables('1', '2', '3', id);
        getBillingCustomerInvoice(vendorCode, edit);

        let token = LOCAL_STORAGE.userToken
        let userId = LOCAL_STORAGE.userId
        let customerNo = LOCAL_STORAGE.customerNo
        let data = JSON.stringify
            ({
                "customer_no": customerNo,
                "user_id": userId,
                "payment_id": paymentID,
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}sales/sales-invoices/getInvoicePaymentMapping`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setMappedPayment(response.data.data)
            // console.log("Mapped Payment ", response.data.data)
        }))
            .catch(error => console.log(error))


    }, [getReceivables])

    if (receivableLoading || billingCustomerInvoiceLoading) {
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {

        //ArrayHelper
        Array.prototype.sum = function (prop) {
            var total = 0
            for (var i = 0, _len = this.length; i < _len; i++) {
                total += +this[i][prop]
            }
            return total
        }

        let activeVendorBillsData = [];

        billingCustomerInvoiceData && receivableData && billingCustomerInvoiceData.map((o, i) => {
            let temp = {}

            // function containsBillId(obj, list) {
            //     var i;
            //     for (i = 0; i < list.length; i++) {
            //         if (list[i].id === obj.id) {
            //             return true;
            //         }
            //     }

            //     return false;
            // }

            temp.checkbox = false
            temp.invoiceDate = o.invoice_date
            temp.referenceNo = o.reference_number
            temp.invoiceNo = o.invoice_no
            temp.clientCode = o.client_name
            temp.invoiceDueDate = o.expected_payment_date
            temp.invoiceAmount = o.invoice_amt
            temp.amountDue = o.pending_amt
            temp.invoiceId = o.id
            temp.payment = ''
            temp.tds = ''

            activeVendorBillsData[i] = temp
        })

        let mappedInvoices = [];
        mappedPayment && mappedPayment.map((invoice, index) => {
            let temp = {}
            temp.invoiceDate = moment(invoice.invoice_details[0].invoice_date).format(dateFormats.DD_MM_YYYY)
            temp.customerInvoiceNo = invoice.invoice_details[0].invoice_no
            temp.invoiceDueDate = moment(invoice.invoice_details[0].expected_payment_date).format(dateFormats.DD_MM_YYYY)
            temp.invoiceReferenceNo = invoice.invoice_details[0].reference_number
            temp.amountDue = invoice.pending_amount
            temp.paidAmount = Number(invoice.paid_amount).toFixed(2)
            temp.invoiceAmount = invoice.invoice_details[0].invoice_amt
            temp.tdsPaid = invoice.tds_paid
            temp.invoiceId = invoice.invoice_id

            mappedInvoices[index] = temp
        })

        const addPaidAmount = mappedInvoices.sum('paidAmount')

        const addPaidTds = mappedInvoices.sum('tdsPaid')
        // console.log("reciverableData", receivableData &&  receivableData[0].client_branch_name)
        //Formik
        const initialValues = {
            customerName: receivableData ? receivableData[0].client_code : '',
            customerBranch: receivableData ? receivableData[0].client_branch_name : '',
            branch: receivableData ? receivableData[0].branch_code : '',
            paymentAmount: receivableData ? receivableData[0].payment_amount : '',
            paymentDate: receivableData ? new Date(receivableData[0].payment_date) : '',
            paymentMode: receivableData ? receivableData[0].payment_mode_code : '',
            bank: receivableData ? receivableData[0].bank_code : '',
            refNo: receivableData ? receivableData[0].reference_number : '',
            activeCustomerInvoices: activeVendorBillsData,
            activeVendorBillSelected: [],
            tdsOnBills: [],
            transactionDate: receivableData ? new Date(receivableData[0].transaction_date) : '',
            notes: '',
            finalPayment: '',
        }

        const validateSchema = yup.object().shape({
            customerName: yup.mixed().required(ERROR_MESSAGES.CUSTOMER_NAME_REQUIRED),
            paymentAmount: yup.mixed().required(ERROR_MESSAGES.PAYMENT_AMOUNT_REQUIRED),
            paymentDate: yup.mixed().required(ERROR_MESSAGES.PAYMENT_DATE_REQUIRED),
            paymentMode: yup.mixed().required(ERROR_MESSAGES.PAYMENT_MODE_REQUIRED),
            refNo: yup.mixed().required(ERROR_MESSAGES.REFERENCE_NO_REQUIRED),
            transactionDate: yup.mixed().required(ERROR_MESSAGES.TRANSACTION_DATE_REQUIRED),
        })

        const onSubmit = (values, onSubmitProps) => {
            const customerNumber = LOCAL_STORAGE.customerNo
            const userId = LOCAL_STORAGE.userId

            const invoices = [];
            values.activeCustomerInvoicesSelected.map((product, index) => {
                let temp = {}
                temp.invoice_id = product.invoiceId
                temp.paid_amount = product.payment
                temp.pending_amount = product.amountDue
                temp.tds_paid = product.tds ? product.tds : 0

                invoices[index] = temp
            });

            let mappedInvoicesOnSubmit = []
            mappedInvoices.map((product, index) => {
                let temp = {}

                temp.invoice_id = product.invoiceId
                temp.paid_amount = product.paidAmount
                temp.pending_amount = product.amountDue
                temp.tds_paid = product.tdsPaid ? product.tdsPaid : 0

                mappedInvoicesOnSubmit[index] = temp

            })
            const updateReceivableData = {
                customer_no: customerNumber,
                user_id: userId,
                reference_number: values?.refNo,
                client_branch_code: values?.customerBranch,
                branch_code: values?.branch || '',
                client_code: receivableData[0]?.client_code,
                payment_date: moment(values?.paymentDate).format(dateFormats.DD_MM_YYYY),
                transaction_date: moment(values?.transactionDate).format(dateFormats.DD_MM_YYYY),
                payment_recieved_date: moment(values?.paymentDate).format(dateFormats.DD_MM_YYYY),
                payment_mode_code: values?.paymentMode,
                chequeNo: values?.chequeNo,
                bank_code: values?.bank,
                complete_payment: values?.paymentAmount === values?.amountDue ? 1 : 0,
                paid_amount: values?.finalPayment,
                payment_amount: Number(+values?.finalPayment + +addPaidAmount + +addPaidTds).toFixed(2),
                tds_amount: 0,
                pending_amount: receivableData[0]?.pending_amount,
                remarks: '',
                mapInvoiceReceivable: mappedInvoicesOnSubmit,
                invoice_list: invoices,
            };

            updateReceivable(updateReceivableData).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });

        };


        return (
            <React.Fragment>
                <AddTitleBar title="Edit Receivable" LinkName="/receivable" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group >
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">{fields.customer.title}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik
                                                    component={BillingPartyDropdown}
                                                    disabled
                                                    name="customerName"
                                                    placeholder={fields.customer.placeholder}
                                                    value={values.customerName}
                                                    customerMasterCode={values.customerName}
                                                />
                                                {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                            </FormUi.Field>

                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{fields.branch.title}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <Fieldmik name="customerBranch" disabled />

                                            </FormUi.Field>
                                            <FormUi.Field width="1">
                                                <label className="labelName mt-2">Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                                <Fieldmik name="branch" disabled />
                                            </FormUi.Field>
                                        </FormUi.Group>

                                        <PaidInvoices mappedInvoices={mappedInvoices} />
                                        {billingCustomerInvoiceLoading ? <LoadingPlaceholder /> : <ActiveVendorBills />}
                                        <FormUi.Group className="mt-4">
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{fields.paymentAmount.title}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                {/* {console.log("Testing ==========> ", values.finalPayment, addPaidAmount, addPaidTds)} */}
                                                <Fieldmik name="paymentAmount" placeholder={fields.paymentAmount.title} value={Number(+values.finalPayment + +addPaidAmount + +addPaidTds).toFixed(2)} />
                                                {touched.paymentAmount && errors.paymentAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentAmount}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{fields.paymentDate.title}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`paymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText={fields.paymentDate.placeholder}
                                                    selected={values.paymentDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.paymentDate && errors.paymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{fields.paymentMode.title}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik
                                                    component={PaymentModeDropdown}
                                                    name="paymentMode"
                                                    placeholder={fields.paymentMode.title}
                                                    setPaymentData={setPaymentData}
                                                    paymentSelected={paymentSelected}
                                                    value={values.paymentMode}
                                                    paymentModeEdit={values.paymentMode}
                                                />
                                                {touched.paymentMode && errors.paymentMode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentMode}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            {paymentName === "CASH" ?
                                                // <>
                                                //     <FormUi.Field width="3">
                                                //         <label className="labelName mt-2">Select Cash Ledger</label>
                                                //     </FormUi.Field>
                                                //     <FormUi.Field width="4">
                                                //         <Fieldmik component={BankDropdown} name="cashLedger" placeholder="Select Cash Ledger" value={values.cashLedger} />
                                                //         {touched.cashLedger && errors.cashLedger ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.cashLedger}</strong> : ''}
                                                //     </FormUi.Field>
                                                // </> 
                                                ""
                                                :
                                                <>
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">{fields.bank.title}</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field width="4">
                                                        <Fieldmik component={BankDropdown} name="bank" placeholder={fields.bank.title} value={values.bank} />
                                                        {touched.bank && errors.bank ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.bank}</strong> : ''}
                                                    </FormUi.Field>
                                                    {paymentName === "CHEQUE" ?
                                                        <>
                                                            <FormUi.Field width="1" />
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">{fields.chequeNo.title}</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="4">
                                                                <Fieldmik name="chequeNo" placeholder={fields.chequeNo.title} />
                                                                {touched.chequeNo && errors.chequeNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.chequeNo}</strong> : ''}
                                                            </FormUi.Field>
                                                        </> : ""
                                                    }
                                                </>}
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{fields.refNo.title}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="refNo" placeholder={fields.refNo.title} />
                                                {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">{fields.transactionDate.title}</label>
                                            </FormUi.Field>
                                            {console.log("Payment Values", values)}
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`transactionDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText={fields.transactionDate.placeholder}
                                                    selected={values.transactionDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.transactionDate && errors.transactionDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.transactionDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group className="mt-4">
                                            <FormUi.Field width="8" />
                                            <FormUi.Field width='3'>
                                                <b style={{ fontWeight: "600" }}>{fields.finalAmount.title}</b>
                                            </FormUi.Field>
                                            <FormUi.Field width='3'>
                                                <b style={{ fontWeight: "600" }}>{fields.currencySymbol} {Number(+values.finalPayment + +addPaidAmount + +addPaidTds).toFixed(2)}</b>
                                            </FormUi.Field>
                                        </FormUi.Group>

                                    </div>
                                </Segment>

                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>{buttons.submit}</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = state => ({
    receivableData: state.getReceivableData.receivables.data,
    receivableLoading: state.getReceivableData.isLoading,
    billingCustomerInvoiceData: state.getCustomerInvoiceData.customerInvoice.data,
    billingCustomerInvoiceLoading: state.getCustomerInvoiceData.isLoading,
})


export default connect(mapStatetoProps, { updateReceivable, getBillingCustomerInvoice, getReceivables })(EditReceivable)


